import p from "./design-system.es58.js";
import { resolveComponent as f, openBlock as l, createElementBlock as r, normalizeClass as m, createElementVNode as y, createTextVNode as o, toDisplayString as c, createCommentVNode as a, renderSlot as u, createVNode as g } from "vue";
/* empty css                    */
/* empty css                    */
import b from "./design-system.es128.js";
const w = {
  name: "DsInputField",
  components: {
    Icon: p
  },
  props: {
    /**
     * Label to render above the input field when active
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Placeholder text for when the input is empty
     */
    placeholder: {
      type: String,
      default: ""
    },
    /**
     * HTML input element name
     */
    name: {
      type: String,
      default: ""
    },
    /**
     * Control hiding the input
     */
    hidden: Boolean,
    /**
     * Prevent user from typing in the input
     */
    readonly: Boolean,
    /**
     * Required field for validation purposes
     */
    required: Boolean,
    /**
     * Number input usage to control how much to increase/decrease with buttons. Also controls how the value is validated.  If set to "any", allows decimal numbers.
     */
    step: [String, Number],
    /**
     * Controls visualization of rendering form validation error states
     */
    submitted: Boolean,
    /**
     * Forces invalid form field
     */
    invalid: Boolean,
    /**
     * Form validation pattern regex
     */
    pattern: {
      type: String,
      default: ""
    },
    /**
     * Input HTML type
     */
    type: {
      type: String,
      default: "text",
      options: ["text", "email", "password", "number", "submit", "search", "url", "tel"]
    },
    /**
     * Control trimming the text value from the input on change to vmodel
     */
    trim: Boolean,
    /**
     * Min length allowed on the input for validation purposes
     */
    minlength: {
      type: Number,
      default: 0
    },
    /**
     * Max length allowed on the input, will prevent user from being able to enter more
     */
    maxlength: {
      type: Number,
      default: 232
    },
    /**
     * Min number allowed for number input
     */
    min: Number,
    /**
     * Max number allowed for number input
     */
    max: Number,
    /**
     * Input value
     */
    modelValue: [String, Number],
    /**
     * Auto focus on this input containing component renders
     */
    autofocus: Boolean,
    /**
     * Control whether you allow users to have the ability to autofill/autocomplete this input from things like Google
     */
    autocomplete: {
      type: [Boolean, String],
      default: !1
    },
    /**
     * Intercept before emitting the update:modelValue event
     */
    interceptOnUpdate: Function,
    /**
     * String list of classes to apply to the input element
     */
    inputClassList: {
      type: String,
      default: ""
    }
  },
  emits: [
    "blur",
    "focus",
    "keydown",
    "keyup",
    "selected",
    "update:modelValue"
  ],
  data() {
    return {
      isPasswordShownAsText: !1,
      dirty: !1,
      value: this.modelValue
    };
  },
  computed: {
    showError() {
      return !!(this.$slots.error && this.submitted);
    },
    autocompleteValue() {
      return typeof this.autocomplete == "boolean" ? this.autocomplete ? "on" : "off" : this.autocomplete;
    },
    hasTrailing() {
      return this.$slots.trailing || this.type === "password";
    },
    localType() {
      return this.isPasswordShownAsText ? this.type === "password" ? "text" : "password" : this.type;
    },
    computedPattern() {
      let e = this.pattern || ".*";
      return this.minlength > 0 && (e = `.{${this.minlength},}`), e;
    }
  },
  watch: {
    modelValue(e) {
      e !== this.parseValue(this.value) && this.setValue(e);
    },
    invalid() {
      this.checkInvalid();
    }
  },
  created() {
    this.setValue(this.parseValue(this.modelValue));
  },
  mounted() {
    this.checkInvalid();
  },
  methods: {
    parseValue(e) {
      if (this.type !== "number" || e === "" || e === void 0 || e === null)
        return e;
      const t = Number(e);
      return this.min && t < this.min || this.max && this.max < t ? "" : t;
    },
    togglePassword() {
      this.isPasswordShownAsText = !this.isPasswordShownAsText, this.$nextTick(() => {
        this.$refs.input.focus();
      });
    },
    handleBlur(e) {
      this.$emit("blur", e);
      const { value: t } = this;
      if (this.type === "number") {
        if (t === 0 || t === "") {
          this.value = void 0, this.$nextTick(() => {
            this.value = t;
          });
          return;
        }
        this.modelValue !== this.value && (this.value = this.modelValue);
      }
    },
    updateInput(e) {
      const t = (i) => {
        this.setValue(i), this.$emit("update:modelValue", this.parseValue(this.value));
      };
      this.interceptOnUpdate && typeof this.interceptOnUpdate == "function" ? this.interceptOnUpdate(e, t) : t(e);
    },
    setValue(e) {
      this.value = this.trim && e ? e.trim() : e, this.dirty = e === 0 || !!e || this.type === "number" && e === "";
    },
    checkInvalid() {
      this.$refs.input && (this.invalid ? this.$refs.input.setCustomValidity("invalid") : this.$refs.input.setCustomValidity(""));
    },
    handleSelect({ target: e } = { target: { selectionStart: null, selectionEnd: null } }) {
      const { selectionStart: t, selectionEnd: i } = e;
      this.$emit("selected", { selectionStart: t, selectionEnd: i });
    },
    input_focus() {
      this.$refs.input.focus();
    },
    input_reportValidity() {
      !this.$refs.input || typeof this.$refs.input.reportValidity != "function" || this.$refs.input.reportValidity();
    }
  }
}, V = ["id", "type", "name", "autofocus", "required", "placeholder", "maxlength", "min", "max", "pattern", "value", "readonly", "step", "autocomplete"], S = ["for"], k = {
  key: 1,
  class: "error-text"
}, v = {
  key: 2,
  class: "assistive-text"
}, x = {
  key: 3,
  class: "leading"
}, B = {
  key: 4,
  class: "trailing"
};
function I(e, t, i, T, d, n) {
  const h = f("Icon");
  return l(), r("div", {
    class: m(["input-field", { "no-label": !i.label }])
  }, [
    y("input", {
      id: i.name,
      ref: "input",
      type: n.localType,
      name: i.name,
      class: m([
        {
          dirty: d.dirty,
          hidden: i.hidden,
          submitted: i.submitted,
          "has-leading": e.$slots.leading,
          "has-trailing": n.hasTrailing
        },
        i.inputClassList
      ]),
      autofocus: i.autofocus,
      required: i.required,
      placeholder: i.placeholder,
      maxlength: i.maxlength,
      min: i.min,
      max: i.max,
      pattern: n.computedPattern,
      value: d.value,
      readonly: i.readonly,
      step: i.step,
      autocomplete: n.autocompleteValue,
      onInput: t[0] || (t[0] = (s) => n.updateInput(s.target.value)),
      onFocus: t[1] || (t[1] = (s) => e.$emit("focus")),
      onBlur: t[2] || (t[2] = (...s) => n.handleBlur && n.handleBlur(...s)),
      onSelect: t[3] || (t[3] = (...s) => n.handleSelect && n.handleSelect(...s)),
      onKeydown: t[4] || (t[4] = (s) => e.$emit("keydown", s)),
      onKeyup: t[5] || (t[5] = (s) => e.$emit("keyup", s))
    }, null, 42, V),
    t[7] || (t[7] = o()),
    i.label ? (l(), r("label", {
      key: 0,
      for: i.name
    }, c(i.label), 9, S)) : a("", !0),
    t[8] || (t[8] = o()),
    n.showError ? (l(), r("span", k, [
      u(e.$slots, "error", {}, void 0, !0)
    ])) : a("", !0),
    t[9] || (t[9] = o()),
    e.$slots.help ? (l(), r("span", v, [
      u(e.$slots, "help", {}, void 0, !0)
    ])) : a("", !0),
    t[10] || (t[10] = o()),
    e.$slots.leading ? (l(), r("div", x, [
      u(e.$slots, "leading", {}, void 0, !0)
    ])) : a("", !0),
    t[11] || (t[11] = o()),
    n.hasTrailing ? (l(), r("div", B, [
      u(e.$slots, "trailing", {}, () => [
        i.type === "password" ? (l(), r("div", {
          key: 0,
          class: "toggle-password",
          onClick: t[6] || (t[6] = (...s) => n.togglePassword && n.togglePassword(...s))
        }, [
          g(h, {
            name: d.isPasswordShownAsText ? "eye-hide" : "eye-show"
          }, null, 8, ["name"])
        ])) : a("", !0)
      ], !0)
    ])) : a("", !0)
  ], 2);
}
const q = /* @__PURE__ */ b(w, [["render", I], ["__scopeId", "data-v-1cbcd5cf"]]);
export {
  q as default
};
//# sourceMappingURL=design-system.es65.js.map
